// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lV6JSHuzSS7bp2mymnfp{background-color:var(--yellow-40)}`, "",{"version":3,"sources":["webpack://./src/pages/conversations/pages/search/ui/Results/ui/HighlighterText/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,iCAAA","sourcesContent":[".highlighter {\n  background-color: var(--yellow-40);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"highlighter": `lV6JSHuzSS7bp2mymnfp`
};
export default ___CSS_LOADER_EXPORT___;
